module.exports = __webpack_public_path__ + "img/calc-1.b714c2a5.png";